document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-menu-button]');
  const menu = document.querySelector('[data-menu]');
  menuButton?.addEventListener('click', () => {
    const open = menu.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.querySelectorAll('[data-product-form]').forEach((form) => {
    const address = form.querySelector('[data-address]');
    const font = form.querySelector('[data-font]');
    const streetField = form.querySelector('[data-street-field]');
    const streetInput = form.querySelector('[data-street-input]');
    const addressPreviews = form.querySelectorAll('[data-preview-address]');
    const streetPreviews = form.querySelectorAll('[data-preview-street]');
    const previewStage = form.querySelector('[data-preview-stage]');
    const variantInput = form.querySelector('[name="id"]');
    const price = document.querySelector('[data-product-price]');
    const submitButton = form.querySelector('.product-submit');
    const variantMessage = form.querySelector('[data-variant-message]');
    const variantDataNode = form.querySelector('[data-variants]');
    const variants = variantDataNode ? JSON.parse(variantDataNode.textContent) : [];
    const optionGroups = [...form.querySelectorAll('[data-product-option]')];

    const selectedOptions = () => optionGroups.map((group) => group.querySelector('[data-option-choice]:checked')?.value || '');

    const getSizeMode = (values) => {
      const size = (values[0] || '').toLowerCase();
      if (size.includes('both')) return 'bundle';
      if (size.includes('large')) return 'large';
      return 'small';
    };

    const hasStreetAddon = (values) => {
      const streetOption = values.find((value, index) => {
        const group = optionGroups[index];
        const optionName = group?.querySelector('legend')?.textContent.toLowerCase() || '';
        return optionName.includes('street');
      });
      return (streetOption || '').toLowerCase().includes('yes');
    };

    const updatePreview = () => {
      const addressValue = address?.value.trim() || '742';
      const streetValue = streetInput?.value.trim() || 'EVERGREEN AVENUE';
      const fontFamily = font?.selectedOptions[0]?.dataset.fontFamily || 'Arial Black, Arial, sans-serif';
      const fontWeight = font?.selectedOptions[0]?.dataset.fontWeight || '900';
      const showStreet = hasStreetAddon(selectedOptions());

      addressPreviews.forEach((preview) => {
        preview.textContent = addressValue;
        preview.style.fontFamily = fontFamily;
        preview.style.fontWeight = fontWeight;
      });
      streetPreviews.forEach((preview) => {
        preview.textContent = streetValue;
        preview.style.fontFamily = fontFamily;
        preview.style.fontWeight = fontWeight;
        preview.hidden = !showStreet;
      });
    };

    const updateProduct = () => {
      const values = selectedOptions();
      const selected = variants.find((variant) => variant.options.every((option, index) => option === values[index]));
      const showStreet = hasStreetAddon(values);

      if (previewStage) previewStage.dataset.mode = getSizeMode(values);
      if (streetField && streetInput) {
        streetField.hidden = !showStreet;
        streetInput.disabled = !showStreet;
        streetInput.required = showStreet;
        if (!showStreet) streetInput.value = '';
      }

      if (!selected) {
        if (variantInput) variantInput.value = '';
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Unavailable combination';
        }
        if (variantMessage) variantMessage.hidden = false;
        updatePreview();
        return;
      }

      variantInput.value = selected.id;
      if (price) {
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: selected.currency || 'USD'
        }).format(selected.price / 100);
      }
      if (submitButton) {
        submitButton.disabled = !selected.available;
        submitButton.textContent = selected.available ? 'Add personalized decals to cart' : 'Sold out';
      }
      if (variantMessage) {
        variantMessage.hidden = selected.available;
        variantMessage.textContent = selected.available ? '' : 'This combination is currently unavailable.';
      }
      updatePreview();
    };

    optionGroups.forEach((group) => group.querySelectorAll('[data-option-choice]').forEach((radio) => radio.addEventListener('change', updateProduct)));
    address?.addEventListener('input', updatePreview);
    streetInput?.addEventListener('input', updatePreview);
    font?.addEventListener('change', updatePreview);
    updateProduct();
  });
});
